import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vip-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "vip-level" }
const _hoisted_4 = { class: "level-num" }


export default /*@__PURE__*/_defineComponent({
  __name: 'VIPItem',
  props: {
        vipLevel: {
            type: Number,
        }
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "vip-bg",
      src: require(`@/assets/images/vip/vip_${__props.vipLevel}.png`)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "vip-text" }, _toDisplayString("VIP "), -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.vipLevel), 1)
    ])
  ]))
}
}

})